var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroDash1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 70,
    height: 230,
    viewBox: "0 0 70 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashed curve"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M60 4C20 60 10 140 40 220",
    stroke: "#7FA4F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "4 6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroDash1);
export default __webpack_public_path__ + "static/media/hero-dash-1.e5f79c92e0362ac109627ae32e53da4f.svg";
export { ForwardRef as ReactComponent };